import script from "./userDetailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./userDetailModal.vue?vue&type=script&setup=true&lang=js"

import "./userDetailModal.vue?vue&type=style&index=0&id=ef088b92&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef088b92"]])

export default __exports__